@if (selectedCell) {
  <div  style="position: absolute;top: 20px;right: 0;left: 0;bottom: 0;/* background: grey; */">
    <app-table-cell-modal
      [selectedCell]="selectedCell"
      [cellControl]="previewForm.controls[selectedCell.key]"
      (onCellUpdated)="onCellUpdated($event)"
    (onClose)="closeModal($event)"></app-table-cell-modal>
  </div>
}
<div style="position:relative">

  <form class="w-100 h-100" [ngStyle]="{'opacity': selectedCell ? 0.5 : 1}" [formGroup]="previewForm">
    <table class="w-100 h-100">

      <tbody>
        @if (tableData?.rows?.length > 0) {
          <tr>
            @for (column of tableData?.columns[0].cells; track column; let columnIndex = $index) {
              <td class="text-center has-border">
                <strong> {{ column.templateOptions.label || 'Column ' + columnIndex + 1 }}</strong>
              </td>
            }
          </tr>
        }
        <!-- Column Header Info Row -->

        @for (row of tableData?.rows; track row; let rowIndex = $index) {
          <tr>
            @for (column of row.cells; track column; let columnIndex = $index) {
              <td
                [ngClass]="{'is-selected' : column.key === selectedCell?.key, 'has-border' : column.key !== selectedCell?.key}"
                (click)="selectCell(column)">
                @if (column.templateOptions?.label && column.templateOptions.label) {
                  <div class="d-flex align-items-center justify-content-center"
                    >
                    {{ column.templateOptions.label }}
                  </div>
                }
                @if (column.type=='input') {
                  <div class="d-flex align-items-center justify-content-center" style="padding:10px 5px">
                    <div class="input-group me-1 ms-1" style="height:36px;min-width: 148px">
                      <input type="text" style="height: 40px;height: 50%;"
                        class="form-control border-right-none"
                        [formControlName]="column.key" id="form-control"
                        placeholder="{{ column.templateOptions.placeholder}}"
                        autocomplete="off">
                      <span class="input-group-text" id="basic-addon2"><img src="assets/img/input-icon.svg" height="9px"></span>
                    </div>
                  </div>
                }
                @if (column.type=='datepicker') {
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="input-group me-1 ms-1" style="height:36px;min-width: 148px">
                      <input [formControlName]="column.key" #startDate="bsDatepicker" name="startDate"
                        class="form-control custom-form-control border-right-none" id="form-control" bsDatepicker autocomplete="off"
                        placeholder="{{column.templateOptions.placeholder}}"
                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-blue', customTodayClass: 'datepicker-today' }"
                        onkeypress="return false;" style="height: 36px;">
                      <span class="input-group-text" id="basic-addon2"><img src="assets/img/datepicker-icon.svg"></span>
                    </div>
                  </div>
                }
                @if (column.type=='number') {
                  <div class="flex-column" style="position:relative;display: flex;" [formGroupName]="column.key">
                    <div class="d-flex justify-content-center align-items-center mt-1" [ngClass]="{'mt-4' : column.templateOptions.min || column.templateOptions.max}">
                      <div class="input-group me-1 ms-1" style="height:36px;min-width: 135px">
                        <input type="number" formControlName="numberFirst"  class="form-control number border-right-none" id="form-control"  placeholder="{{column.templateOptions.placeholder}}"
                          autocomplete="off" description="xx" [ngStyle]="column.templateOptions['precision'] && {'min-width':'50px'}">
                        <span class="input-group-text" id="basic-addon2"><img src="assets/img/number-icon.svg"></span>
                      </div>
                      @if (column.templateOptions['precision']!== null && column.templateOptions['precision']) {
                        <span style="margin-left:6px;margin-right:6px;padding-top: 29px;" class="label-preview">.</span>
                      }
                      @if (column.templateOptions['precision']!== null && column.templateOptions['precision']) {
                        <div class="input-group me-1 ms-1" style="height:36px;min-width: 135px">
                          <input type="number" formControlName="numberSecond"  class="form-control number border-right-none" id="form-control"
                            autocomplete="off" style="min-width: 50px;">
                          <span class="input-group-text" id="basic-addon2"><img src="assets/img/number-icon.svg"></span>
                        </div>
                      }
                      @if (column.templateOptions['unit']!== null && column.templateOptions['unit']) {
                        <span style="margin-left:2px;width: auto;" class="label-preview fs-12">{{column.templateOptions['unit']}}</span>
                      }
                    </div>
                    <div class="d-flex align-items-start">
                      @if (column.templateOptions.min || column.templateOptions.min == 0) {
                        <label class="label-preview-title fs-12 pb-1">Min : {{column.templateOptions.min}}</label>
                      }
                      @if (column.templateOptions.max || column.templateOptions.max == 0) {
                        <label class="label-preview-title fs-12 ps-2 pb-1">Max : {{column.templateOptions.max}}</label>
                      }
                    </div>
                  </div>
                }
                @if (column.type=='empty') {
                  <div class="d-flex align-items-center justify-content-center">
                    <span style="min-width: 90px"></span>
                  </div>
                }
                @if (column.type == 'multicheckbox') {
                  <div class="d-flex align-items-center justify-content-start ms-2">
                    <div class="form-check text-start">
                      @for (optionGroup of getMultiCheckboxOptions(column.key); track optionGroup; let i = $index) {
                        <div [formGroup]="optionGroup">
                          <input type="checkbox" class="form-check-input" [id]="'input-'+optionGroup.value.option"
                            formControlName="value"/>
                          @if (optionGroup.value.option) {
                            <label class="form-check-label" [for]="'input-'+optionGroup.value.option"
                              >
                              {{ optionGroup.value.option }}
                            </label>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (column.type=='radio') {
                  <div class="d-flex align-items-center justify-content-start ms-2">
                    <div class="form-check text-start">
                      @for (option of column.templateOptions?.options; track option) {
                        <div>
                          <input type="radio" class="form-check-input" [id]="'input-'+column.key+option.value"
                            [value]="option.value"
                            [formControlName]="column.key"/>
                          @if (option.label) {
                            <label class="form-check-label" [for]="'input-'+column.key+option.value"
                              >
                              {{ option.label }}
                            </label>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </form>
</div>
